import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from "redux"
import Actions from "../../actions"
import Sidebar from "react-sidebar"
import { Button, DisplayText, Card, TextField, Icon, Stack, Toast } from "@shopify/polaris"
import {
    ChevronLeftMinor,
    ArrowRightMinor,
    SettingsMajor,
    ChevronRightMinor,
} from "@shopify/polaris-icons"
import TemplateCustom from "../../components/WishlistApp/TemplateCustom"
import Preloader from "../../components/Preloader"
import axios from "../../funcs/axios"
const INITIAL_STATE = {
    isReady: false,
    isLoading: false,
    openSidebar: false,
    openTemplateCustom: false,
    toast: {
        show: false,
        content: "",
        error: false,
    },
    wishlist_settings_edited: [],
    compare_settings_edited: [],
    general_settings_edited: [],
    errorValidate: {
        error_1: "", // wishlist add class error
        error_2: "", // wishlist show class error
        error_2a: "", // wishlist remove class error
        error_3: "", // compare add class error
        error_4: "", // compare show class error
        error_4a: "", // compare remove class error
    },
}

function mapStateToProps(state) {
    return {
        yout_app: state.yout_app,
        widgets: state.widgets,
        widget_selected: state.widget_selected,
        app_edited: state.app_edited,
        app_render: state.app_render,
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Actions, dispatch),
    }
}

class ComparePage extends Component {
    constructor(props) {
        super(props)
        this.state = Object.assign({}, INITIAL_STATE)
        // this.child = React.createRef();
    }

    static getDerivedStateFromProps(props, state) {
        const { widget_selected } = props

        if (JSON.stringify(widget_selected) !== "{}") {
            return { isReady: true }
        }

        return null
    }

    componentDidMount() {
        const { actions, yout_app } = this.props
    }

    renderLeftContent = () => {
        const { redirectToPage } = this.props
        return <TemplateCustom goBack={async () => redirectToPage("WidgetsManagement")} />
    }

    renderPreviewHeader() {
        const { widget_selected } = this.props
        const { compare_settings } = this.props.app_render
        const { launch_show } = compare_settings
        return (
            <div style={{ padding: "20px" }}>
                <Stack alignment="center">
                    <Stack.Item>
                        <svg
                            width="1.125em"
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="home"
                            className="svg-inline--fa fa-home fa-w-18 fa-2x "
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 576 512"
                            style={{ color: "rgb(224, 241, 255)" }}
                        >
                            <path
                                fill="currentColor"
                                d="M280.37 148.26L96 300.11V464a16 16 0 0 0 16 16l112.06-.29a16 16 0 0 0 15.92-16V368a16 16 0 0 1 16-16h64a16 16 0 0 1 16 16v95.64a16 16 0 0 0 16 16.05L464 480a16 16 0 0 0 16-16V300L295.67 148.26a12.19 12.19 0 0 0-15.3 0zM571.6 251.47L488 182.56V44.05a12 12 0 0 0-12-12h-56a12 12 0 0 0-12 12v72.61L318.47 43a48 48 0 0 0-61 0L4.34 251.47a12 12 0 0 0-1.6 16.9l25.5 31A12 12 0 0 0 45.15 301l235.22-193.74a12.19 12.19 0 0 1 15.3 0L530.9 301a12 12 0 0 0 16.9-1.6l25.5-31a12 12 0 0 0-1.7-16.93z"
                            />
                        </svg>
                    </Stack.Item>
                    <Stack.Item fill></Stack.Item>
                    <Stack.Item>
                        <div
                            style={{
                                width: "200px",
                                height: "18px",
                                backgroundColor: "rgb(224, 241, 255)",
                            }}
                        />
                    </Stack.Item>
                    {widget_selected.id == 0 && launch_show.type == "header" ? (
                        <Stack.Item>
                            <svg
                                width="1.125em"
                                aria-hidden="true"
                                focusable="false"
                                data-prefix="far"
                                data-icon="heart"
                                className="svg-inline--fa fa-heart fa-w-16 "
                                role="img"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 26 22"
                                style={{ color: "rgb(255, 69, 0)" }}
                            >
                                <path
                                    fill="currentColor"
                                    d="M21.6334 13.2821C21.6334 13.3333 21.6334 13.3675 21.6334 13.3846C21.0175 15.9487 19.7344 18.0256 17.784 19.6154C15.8337 21.2051 13.5497 22 10.9322 22C9.54641 22 8.20341 21.735 6.90318 21.2051C5.60295 20.6752 4.43959 19.9231 3.4131 18.9487L1.56541 20.7949C1.37722 20.9829 1.16336 21.0769 0.923846 21.0769C0.68433 21.0769 0.470477 20.9829 0.282286 20.7949C0.0940954 20.6068 0 20.3932 0 20.1538V13.7436C0 13.5043 0.0940954 13.2906 0.282286 13.1026C0.470477 12.9145 0.68433 12.8205 0.923846 12.8205H7.33944C7.57896 12.8205 7.79281 12.9145 7.981 13.1026C8.16919 13.2906 8.25474 13.5043 8.23763 13.7436C8.22052 13.9829 8.13498 14.1966 7.981 14.3846L6.005 16.359C6.68933 16.9744 7.4592 17.4615 8.31462 17.8205C9.17003 18.1795 10.0682 18.3504 11.0092 18.3333C12.2752 18.3333 13.4642 18.0171 14.5762 17.3846C15.6883 16.7521 16.5779 15.906 17.2451 14.8462C17.3478 14.6752 17.6044 14.1111 18.015 13.1538C18.0834 12.9316 18.2203 12.8205 18.4256 12.8205H21.1715C21.3083 12.8205 21.4195 12.8718 21.5051 12.9744C21.5906 13.0769 21.6334 13.1795 21.6334 13.2821ZM21.9927 1.84615V8.25641C21.9927 8.49573 21.9071 8.7094 21.736 8.89744C21.565 9.08547 21.3426 9.17949 21.0688 9.17949H14.6532C14.4137 9.17949 14.1999 9.08547 14.0117 8.89744C13.8235 8.7094 13.7379 8.49573 13.755 8.25641C13.7721 8.01709 13.8577 7.80342 14.0117 7.61538L15.9877 5.64103C14.5848 4.32479 12.9253 3.66667 11.0092 3.66667C9.72605 3.66667 8.52847 3.98291 7.41643 4.61539C6.30439 5.24786 5.41476 6.09402 4.74754 7.15385C4.64489 7.32479 4.39682 7.88889 4.00333 8.84616C3.91779 9.06838 3.77237 9.17949 3.56707 9.17949H0.718547C0.598789 9.17949 0.487585 9.12821 0.384936 9.02564C0.282286 8.92308 0.239516 8.82051 0.256624 8.71795V8.61539C0.872521 6.05128 2.16419 3.97436 4.13164 2.38462C6.09909 0.794873 8.3916 0 11.0092 0C12.3949 0 13.7465 0.264958 15.0638 0.794872C16.3812 1.32479 17.5531 2.07692 18.5796 3.05128L20.4273 1.20513C20.6155 1.01709 20.8293 0.923078 21.0688 0.923078C21.3083 0.923078 21.5307 1.01709 21.736 1.20513C21.9413 1.39316 22.0269 1.60684 21.9927 1.84615Z"
                                />
                            </svg>
                        </Stack.Item>
                    ) : (
                        ""
                    )}
                </Stack>
            </div>
        )
    }

    renderPreviewMenu() {
        const { widget_selected } = this.props
        const { compare_settings } = this.props.app_render
        const { launch_show } = compare_settings
        let item = []
        let i = 0
        for (i; i < 3; i++) {
            item.push(
                <Stack.Item key={i}>
                    <div
                        style={{
                            width: "50px",
                            height: "12px",
                            backgroundColor: "rgb(224, 241, 255)",
                        }}
                    />
                </Stack.Item>,
            )
        }
        if (widget_selected.id == 0 && launch_show.type == "menu") {
            item.push(
                <Stack.Item key={i + 1}>
                    <div>COMPARE</div>
                </Stack.Item>,
            )
        }
        return (
            <div className="center-flex">
                <Stack alignment="center">{item}</Stack>
            </div>
        )
    }

    renderPreviewContentProductPage() {
        console.log('dsdsds');
        const { widget_selected } = this.props
        const { compare_settings } = this.props.app_render
        const { launch_add_product_page } = compare_settings
        let item = []
        for (let i = 0; i < 4; i++) {
            item.push(
                <Stack.Item key={i}>
                    <div className="line" />
                </Stack.Item>,
            )
        }
        return (
            <Stack>
                <Stack.Item>
                    <div className="center-flex content-img">
                        <svg
                            height="84px"
                            width="84px"
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="image"
                            className="svg-inline--fa fa-image fa-w-16 fa-6x "
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            style={{ color: "rgb(224, 241, 255)" }}
                        >
                            <path
                                fill="currentColor"
                                d="M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
                            />
                        </svg>
                    </div>
                </Stack.Item>
                <Stack.Item fill>
                    <div className="center-flex">
                        <Stack vertical>
                            {widget_selected.id == 2 ? (
                                <div className="add-wl-parent" style={{
                                    margin: compare_settings.add_selector.margin !== 'undefined' ? compare_settings.add_selector.margin : '',
                                    padding: compare_settings.add_selector.padding !== 'undefined' ? compare_settings.add_selector.padding: '',
                                }}>
                                    <div
                                        className="add-wl"
                                        style={
                                            launch_add_product_page.showBackground
                                                ? launch_add_product_page.showTittle
                                                    ? {
                                                          backgroundColor:
                                                              launch_add_product_page.background_color,
                                                          width:
                                                              launch_add_product_page.width + "px",
                                                          height:
                                                              launch_add_product_page.height + "px",
                                                          borderRadius:
                                                              launch_add_product_page.borderRadius +
                                                              "px",
                                                      }
                                                    : {
                                                          backgroundColor:
                                                              launch_add_product_page.background_color,
                                                          width:
                                                              launch_add_product_page.width + "px",
                                                          height:
                                                              launch_add_product_page.height + "px",
                                                          borderRadius:
                                                              launch_add_product_page.borderRadius +
                                                              "px",
                                                      }
                                                : {}
                                        }
                                    >
                                        <svg
                                            width={compare_settings.add_class_icon_product.width}
                                            height={compare_settings.add_class_icon_product.height}
                                            aria-hidden="true"
                                            focusable="false"
                                            fill={compare_settings.add_class_icon_product.icon_color}
                                            role="img"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox={compare_settings.add_class_icon_product.view_box}
                                            dangerouslySetInnerHTML={{
                                                __html: compare_settings.add_class_icon_product.svg,
                                            }}
                                        ></svg>
                                    </div>
                                    <div
                                        className={"title-wl"}
                                        style={{
                                            color: launch_add_product_page.text_color,
                                            marginLeft: "10px",
                                        }}
                                    >
                                        {launch_add_product_page.showTittle && (
                                            <span>{launch_add_product_page.text}</span>
                                        )}
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                            {item}
                        </Stack>
                    </div>
                </Stack.Item>
            </Stack>
        )
    }

    renderPreviewContent() {
        const { widget_selected } = this.props
        const { compare_settings } = this.props.app_render
        const { launch_add } = compare_settings
        let item = []
        for (let i = 0; i < 4; i++) {
            item.push(
                <Stack.Item key={i}>
                    <div className="line" />
                </Stack.Item>,
            )
        }
        return (
            <Stack>
                <Stack.Item>
                    <div className="center-flex content-img">
                        <svg
                            height="84px"
                            width="84px"
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="image"
                            className="svg-inline--fa fa-image fa-w-16 fa-6x "
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            style={{ color: "rgb(224, 241, 255)" }}
                        >
                            <path
                                fill="currentColor"
                                d="M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
                            />
                        </svg>
                    </div>
                </Stack.Item>
                <Stack.Item fill>
                    <div className="center-flex">
                        <Stack vertical>
                            {widget_selected.id == 1 ? (
                                <div className="add-wl-parent">
                                    <div
                                        className="add-wl"
                                        style={
                                            launch_add.showBackground
                                                ? launch_add.showTittle
                                                    ? {
                                                          backgroundColor:
                                                              launch_add.background_color,
                                                          width: launch_add.width + "px",
                                                          height: launch_add.height + "px",
                                                          borderRadius:
                                                              launch_add.borderRadius + "px",
                                                      }
                                                    : {
                                                          backgroundColor:
                                                              launch_add.background_color,
                                                          width: launch_add.width + "px",
                                                          height: launch_add.height + "px",
                                                          borderRadius:
                                                              launch_add.borderRadius + "px",
                                                      }
                                                : {}
                                        }
                                    >
                                        <svg
                                            width={compare_settings.add_class_icon.width}
                                            height={compare_settings.add_class_icon.height}
                                            aria-hidden="true"
                                            focusable="false"
                                            fill={compare_settings.add_class_icon.icon_color}
                                            role="img"
                                            xmlns="http://www.w3.org/2000/svg"
                                            viewBox={compare_settings.add_class_icon.view_box}
                                            dangerouslySetInnerHTML={{
                                                __html: compare_settings.add_class_icon.svg,
                                            }}
                                        ></svg>
                                    </div>
                                    <div
                                        className={"title-wl"}
                                        style={{ color: launch_add.text_color, marginLeft: "10px" }}
                                    >
                                        {launch_add.showTittle && <span>{launch_add.text}</span>}
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                            {item}
                        </Stack>
                    </div>
                </Stack.Item>
            </Stack>
        )
    }

    renderPreviewFooter() {
        let item = []
        for (let i = 0; i < 3; i++) {
            item.push(
                <Stack.Item key={i}>
                    <div
                        className="center-flex"
                        style={{
                            height: "90px",
                            width: "140px",
                            border: "2px solid rgb(224, 241, 255)",
                        }}
                    >
                        <svg
                            height="42px"
                            width="42px"
                            aria-hidden="true"
                            focusable="false"
                            data-prefix="fas"
                            data-icon="image"
                            className="svg-inline--fa fa-image fa-w-16 fa-3x "
                            role="img"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 512 512"
                            style={{ color: "rgb(224, 241, 255)" }}
                        >
                            <path
                                fill="currentColor"
                                d="M464 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h416c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM112 120c-30.928 0-56 25.072-56 56s25.072 56 56 56 56-25.072 56-56-25.072-56-56-56zM64 384h384V272l-87.515-87.515c-4.686-4.686-12.284-4.686-16.971 0L208 320l-55.515-55.515c-4.686-4.686-12.284-4.686-16.971 0L64 336v48z"
                            />
                        </svg>
                    </div>
                </Stack.Item>,
            )
        }
        return (
            <Stack vertical>
                <Stack.Item>
                    <div
                        style={{
                            width: "460px",
                            height: "4px",
                            backgroundColor: "rgb(224, 241, 255)",
                        }}
                    />
                </Stack.Item>
                <Stack.Item>
                    <div
                        style={{
                            width: "460px",
                            height: "4px",
                            backgroundColor: "rgb(224, 241, 255)",
                        }}
                    />
                </Stack.Item>
                <Stack.Item>
                    <Stack distribution="fillEvenly">{item}</Stack>
                </Stack.Item>
            </Stack>
        )
    }

    render() {
        const { redirectToPage, actions, widget_selected } = this.props
        const { compare_settings } = this.props.app_render
        const { openSidebar, toast, isReady, isLoading } = this.state
        const { launch_show } = compare_settings
        const { position_button } = launch_show

        let title = ""
        switch (widget_selected.id) {
            case 0:
                title = "Show compare button setting"
                break
            case 1:
                title = "Add to Compare Button setting"
                break
            case 2:
                title = "Add to Compare Button setting on product page"
                break
            case 3:
                title = "Remove compare button setting"
                break
            default:
                title = "Show compare button setting"
        }

        return isReady ? (
            <div className="widget-create">
                {isLoading && <Preloader />}

                <Card.Section>
                    <div className="page-breadcrumbs">
                        <Button
                            plain
                            icon={ChevronLeftMinor}
                            size="slim"
                            onClick={async () => redirectToPage("WidgetsManagement")}
                        >
                            Back to list
                        </Button>
                    </div>

                    <div className="page-title">{title}</div>
                </Card.Section>

                <Card.Section>
                    <div className="section-title">
                        <DisplayText size="small">Adjust settings</DisplayText>
                    </div>

                    {/* Mobile section */}
                    <div
                        className="mobile-section-title"
                        onClick={() => this.setState({ openSidebar: !openSidebar })}
                    >
                        <div className="title">
                            <div className="btn-icon">
                                {openSidebar ? (
                                    <Icon source={ChevronLeftMinor} color="white" />
                                ) : (
                                    <Icon source={SettingsMajor} color="white" />
                                )}
                            </div>
                            <div className="subtitle">
                                {openSidebar ? "Back to preview" : "Wiget Settings"}
                            </div>
                        </div>
                        <div className="btn-icon">
                            {!openSidebar && <Icon source={ChevronRightMinor} color="white" />}
                        </div>
                    </div>

                    {/* Desktop section */}
                    <div className="widget-create-body" id="yta-widget-create-body">
                        <div className="left-content">{this.renderLeftContent()}</div>
                        <div className="right-content">
                            <div className="preview-block">
                                <div className="centered-content preview-component">
                                    <div className="page-review">
                                        <Card>
                                            {this.renderPreviewHeader()}
                                            <hr
                                                style={{ border: "1px solid rgb(224, 241, 255)" }}
                                            />
                                            {widget_selected.id == 0 &&
                                            launch_show.type == "floating" ? (
                                                <div
                                                    className="floating"
                                                    style={{
                                                        backgroundColor:
                                                            position_button.background_color,
                                                        minWidth: position_button.minWidth,
                                                        minHeight: position_button.minHeight,
                                                        height: position_button.height + "px",
                                                        width: position_button.width + "px",
                                                        bottom: position_button.bottom,
                                                        right: position_button.right,
                                                        left: position_button.left,
                                                        top: position_button.top,
                                                        color: position_button.text_color,
                                                        position: position_button.position,
                                                        boxShadow: position_button.boxShadow,
                                                        borderRadius:
                                                            position_button.borderRadius + "px",
                                                    }}
                                                >
                                                    <div className="show-wl">
                                                        <div className="title-wl">
                                                            <svg
                                                                width={
                                                                    compare_settings.show_class_icon
                                                                        .width
                                                                }
                                                                height={
                                                                    compare_settings.show_class_icon
                                                                        .height
                                                                }
                                                                aria-hidden="true"
                                                                focusable="false"
                                                                fill={
                                                                    compare_settings.show_class_icon
                                                                        .icon_color
                                                                }
                                                                role="img"
                                                                xmlns="http://www.w3.org/2000/svg"
                                                                viewBox={
                                                                    compare_settings.show_class_icon
                                                                        .view_box
                                                                }
                                                                dangerouslySetInnerHTML={{
                                                                    __html: compare_settings
                                                                        .show_class_icon.svg,
                                                                }}
                                                            ></svg>
                                                            {launch_show.showTittle && (
                                                                <span>{launch_show.text}</span>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            ) : (
                                                ""
                                            )}
                                            {this.renderPreviewMenu()}
                                            <hr
                                                style={{ border: "1px solid rgb(224, 241, 255)" }}
                                            />
                                            <div className="pg-content">
                                                {widget_selected.id != 2 &&
                                                    this.renderPreviewContent()}
                                                {widget_selected.id == 2 &&
                                                    this.renderPreviewContentProductPage()}
                                                <br />
                                                {this.renderPreviewFooter()}
                                            </div>
                                        </Card>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className={`sidebar sidebar-${openSidebar ? "open" : "hidden"}`}>
                            <Sidebar
                                sidebar={this.renderLeftContent()}
                                open={openSidebar}
                                onSetOpen={() => this.setState({ openSidebar: !openSidebar })}
                            >
                                <div></div>
                            </Sidebar>
                        </div>
                    </div>
                </Card.Section>

                {toast.show && (
                    <Toast
                        content={toast.content}
                        error={toast.error}
                        onDismiss={() =>
                            this.setState({
                                toast: { show: false, content: "", error: false },
                            })
                        }
                    />
                )}
            </div>
        ) : (
            <Preloader />
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ComparePage)
